import { API_ENDPOINTS } from "@utils/api/endpoints";
import { useAuthStore } from '@stores/auth';

export default async function (id, body) {
  const auth = useAuthStore();
  const { idSupplier } = auth;
  const { data, error, status } = await useApiFetch(API_ENDPOINTS.SUPPLIER_ID_IMAGE_ID, {
    method: 'PUT',
    path: { idSupplier, id },
    body
  });

  if (status.value === 'error') {
    sentryCaptureEvent({
      message: 'supplier-image-update',
      level: 'error',
      extra: { error: error.value }
    });

    return null;
  }

  return data.value;
}
